// src/assets/schema.ts
export type FieldType = 'text' | 'number' | 'date' | 'select';

export interface FieldDef {
  name: string;
  label: string;
  type: FieldType;
  placeholder?: string;
  options?: { value: string; label: string }[];
  colSpan?: number;
  toView?: (v: any) => any;
  toStore?: (v: any) => any;
}
export type FieldGroup = FieldDef[];

export const amcStatusOptions = [
  { value: 'not-applicable', label: 'Not Applicable' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'expired', label: 'Expired' },
  { value: 'pending', label: 'Pending' },
];

export const toISOInput = (v: any) => (typeof v === 'string' ? v.split('T')[0] : '');
export const fromISOInput = (v: any) => {
  if (!v) return null;
  const [y, m, d] = v.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(Date.UTC(y, m - 1, d, 0, 0, 0, 0)).toISOString();
};

export const SCHEMAS: Record<string, FieldGroup> = {
  extinguisher: [
    { name: 'cylinderNumber', label: 'CYLINDER NO', type: 'text' },
    { name: 'capacity', label: 'CAPACITY', type: 'text' },
    { name: 'type', label: 'TYPE', type: 'text' },
    { name: 'floor', label: 'Floor', type: 'text' },
    { name: 'location', label: 'LOCATION', type: 'text' },
    { name: 'hptTestDate', label: 'HPT Test Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
    { name: 'nextServiceDueDate', label: 'Next Service Due Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
    { name: 'lastRefillDate', label: 'Last Refill Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
    { name: 'nextRefillDueDate', label: 'Next Refill Due Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
    { name: 'amcStatus', label: 'AMC Status', type: 'select', options: amcStatusOptions },
    { name: 'amcVendor', label: 'AMC Vendor', type: 'text', placeholder: 'Enter AMC vendor name' },
    { name: 'amcStartDate', label: 'AMC Start Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
    { name: 'amcEndDate', label: 'AMC End Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
  ],
  alarm: [
    { name: 'panelNo', label: 'Panel No', type: 'text' },
    { name: 'loopNo', label: 'Loop No', type: 'text' },
    { name: 'deviceNo', label: 'Device No', type: 'text' },
    { name: 'loopType', label: 'Loop Type', type: 'text' },
    { name: 'amcStatus', label: 'AMC Status', type: 'select', options: amcStatusOptions },
    { name: 'amcVendor', label: 'AMC Vendor', type: 'text', placeholder: 'Enter AMC vendor name' },
    { name: 'amcStartDate', label: 'AMC Start Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
    { name: 'amcEndDate', label: 'AMC End Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
  ],
  door: [
    { name: 'description', label: 'Description', type: 'text', colSpan: 2 },
    { name: 'location', label: 'Location', type: 'text' },
    { name: 'qty', label: 'QTY', type: 'number' },
    { name: 'amcStatus', label: 'AMC Status', type: 'select', options: amcStatusOptions },
    { name: 'amcVendor', label: 'AMC Vendor', type: 'text', placeholder: 'Enter AMC vendor name' },
    { name: 'amcStartDate', label: 'AMC Start Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
    { name: 'amcEndDate', label: 'AMC End Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
  ],
  hydrant: [
    { name: 'HB_No', label: 'HB No', type: 'text' },
    // { name: 'description', label: 'Description', type: 'text', colSpan: 2 },
    // { name: 'location', label: 'Location', type: 'text' },
    // { name: 'qty', label: 'QTY', type: 'number' }, 
    // { name: 'floor', label: 'Floor', type: 'text' },
    { name: 'amcStatus', label: 'AMC Status', type: 'select', options: amcStatusOptions },
    { name: 'amcVendor', label: 'AMC Vendor', type: 'text', placeholder: 'Enter AMC vendor name' },
    { name: 'amcStartDate', label: 'AMC Start Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
    { name: 'amcEndDate', label: 'AMC End Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
  ],
  pump: [
    // { name: 'type', label: 'Type', type: 'text' },
    // { name: 'description', label: 'Description', type: 'text', colSpan: 2 },
    // { name: 'location', label: 'Location', type: 'text' },
    // { name: 'qty', label: 'QTY', type: 'number' },
    // { name: 'floor', label: 'Floor', type: 'text' },
    { name: 'amcStatus', label: 'AMC Status', type: 'select', options: amcStatusOptions },
    { name: 'amcVendor', label: 'AMC Vendor', type: 'text', placeholder: 'Enter AMC vendor name' },
    { name: 'amcStartDate', label: 'AMC Start Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
    { name: 'amcEndDate', label: 'AMC End Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
  ],
  sprinkler: [
    { name: 'type', label: 'Type', type: 'text' },
    { name: 'description', label: 'Description', type: 'text', colSpan: 2 },
    { name: 'location', label: 'Location', type: 'text' },
    { name: 'qty', label: 'QTY', type: 'number' },
    // { name: 'floor', label: 'Floor', type: 'text' },
    { name: 'amcStatus', label: 'AMC Status', type: 'select', options: amcStatusOptions },
    { name: 'amcVendor', label: 'AMC Vendor', type: 'text', placeholder: 'Enter AMC vendor name' },
    { name: 'amcStartDate', label: 'AMC Start Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
    { name: 'amcEndDate', label: 'AMC End Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
  ],
  default: [
    { name: 'description', label: 'Description', type: 'text', colSpan: 2 },
    { name: 'amcStatus', label: 'AMC Status', type: 'select', options: amcStatusOptions },
    { name: 'amcVendor', label: 'AMC Vendor', type: 'text', placeholder: 'Enter AMC vendor name' },
    { name: 'amcStartDate', label: 'AMC Start Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
    { name: 'amcEndDate', label: 'AMC End Date', type: 'date', toView: toISOInput, toStore: fromISOInput },
  ],
};

export const resolveKey = (name?: string) => {
  const n = (name || '').toLowerCase();
  if (n.includes('extinguisher')) return 'extinguisher';
  if (n.includes('alarm')) return 'alarm';
  if (n.includes('door')) return 'door';
  if (n.includes('hydrant')) return 'hydrant';
  if (n.includes('pump')) return 'pump';
  if (n.includes('sprinkler')) return 'sprinkler';
  return 'default';
};
